<template>
  <div class="profile page">
    <h1>Profile</h1>
    <p><strong>User ID:</strong> {{ user.id }}</p>
    <p><strong>Email:</strong> {{ user.email }}</p>
    <transition>
      <router-view v-if="$currentUser.id"></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ProfilePage',
  data () {
    return {
      user: JSON.parse(localStorage.getItem('userData')) || {}
    }
  }
}
</script>
